import React from "react";
import styled from "styled-components";
import { Button } from "./button/Button";
import { botoxColors, colors, rawColors } from "./colors/color";
import { Flex } from "./compositeComponents/FlexHelpers";
import { Icon, iconName } from "./icons/Icons";
import { TooltipTheOneWrapper } from "./TooltipTheOne";

const tableRadius = '4px';

export const Table = styled.table<{fontSizePx?:number, noOuterBorder?: boolean}>`
 
    border-spacing: 0;
    border-collapse: separate;
    border: 1px solid ${botoxColors.gray.normal};
    border-radius: ${tableRadius};
    ${props => props.noOuterBorder && 
        `border: 0;`
    }
    width: 100%;
    thead {
        th {
            font-weight: normal;
            font-size: ${props => props.fontSizePx ? `${props.fontSizePx}px` : 'inherit'};
            line-height: 24px;
            letter-spacing: 0.5px;
            padding: 6px 8px;
            text-align: left;

            background-color: ${botoxColors.gray.light};
            color: ${botoxColors.gray.dark};
            border-bottom: 1px solid ${botoxColors.gray.normal};
            
            button {
                font-weight: bold;
            }
        }

        th:first-child {
            padding-left: 12px;
            border-top-left-radius: ${props => props.noOuterBorder ? '0' : tableRadius};
        }
        th:last-child {
            padding-left: 12px;
            border-top-right-radius: ${props => props.noOuterBorder ? '0' : tableRadius};
        }
    }
    tr {
        td {
            padding:8px;
            background-color: ${rawColors.white};
            color:${colors.table.cellText};
            text-align: left;
            font-size: ${props => props.fontSizePx ? `${props.fontSizePx}px` : '16px'};
            border-bottom: 1px solid ${botoxColors.gray.normal};
        }
        td:first-child{
            padding-left:12px;
        }
        td:last-child{
            padding-right:12px;
        }
    }
    tbody tr:last-child {
        td {
            border-bottom: none;
        }
        td:first-child {
            border-bottom-left-radius: ${tableRadius};
        }
        td:last-child {
            border-bottom-right-radius: ${tableRadius};
        }
    }
`;

type TableRowWithOnClickProps =
{
    onClick?: () => void,
    children: React.ReactNode
};
export function TableRowWithOnClick (props: TableRowWithOnClickProps): JSX.Element
{

    function handleKeyPress(event: React.KeyboardEvent<HTMLTableRowElement>) {
        if (event.key === 'Enter' && props.onClick) {
            props.onClick();
        }
    }

    return (
        <>
            {props.onClick
                ? <TrWithOnClick role="button" tabIndex={0} onClick={props.onClick} onKeyPress={handleKeyPress}>
                    {props.children}
                </TrWithOnClick>
                : <tr>
                    {props.children}
                </tr>
            }
        </>
    );
}

const TrWithOnClick = styled.tr`
    cursor:pointer;
    &:hover td {
        background-color:${colors.table.backgroundHover};
    }

    /* &:nth-child(even){
        background-color:${colors.table.trEven};

        &:hover {
            background-color:${colors.table.backgroundHover};
        }
    } */
`;

type TableHeaderWithSortProps = {
    text: string,
    width?:string,
    isActiveSort: boolean,
    ascending: boolean,
    onClick: (ascending: boolean) => void;
};
export function TableHeaderWithSort (props: TableHeaderWithSortProps): JSX.Element
{
    return (
        <th style={{ whiteSpace: 'nowrap', paddingLeft: '8px', width: props.width }}>
            <Flex flexDirection='row' alignItems='center'>
                <span>{props.text}</span>
                <SortDirectionButton isActiveSort={props.isActiveSort} ascending={props.ascending} onClick={props.onClick} />
            </Flex>
        </th>
    );
}

type TableHeaderIconProps = {
    icon: iconName,
    tooltipContent:React.ReactNode,
    width?: string,
};
export function TableHeaderIcon (props: TableHeaderIconProps): JSX.Element
{
    return (
        <th style={{ whiteSpace: 'nowrap', paddingLeft: '8px', width:props.width }}>
            <Flex flexDirection='row' alignItems='center'>
                <TooltipTheOneWrapper tooltipContent={props.tooltipContent} >
                    <Icon name={props.icon} />
                </TooltipTheOneWrapper>
            </Flex>
        </th>
    );
}

type TableHeaderIconWithSortProps = {
    icon: iconName,
    tooltipContent:React.ReactNode,
    isActiveSort: boolean,
    ascending: boolean,
    width?: string,
    onClick: (ascending: boolean) => void;
};
export function TableHeaderIconWithSort (props: TableHeaderIconWithSortProps): JSX.Element
{
    return (
        <th style={{ whiteSpace: 'nowrap', paddingLeft: '8px', width: props.width }}>
            <Flex flexDirection='row' alignItems='center'>
                <TooltipTheOneWrapper tooltipContent={props.tooltipContent} >
                    <Icon name={props.icon} />
                </TooltipTheOneWrapper>
                <SortDirectionButton isActiveSort={props.isActiveSort} ascending={props.ascending} onClick={props.onClick} />
            </Flex>
        </th>
    );
}

type SortDirectionButtonProps = {
    isActiveSort: boolean,
    ascending: boolean,
    onClick: (ascending: boolean) => void;
};
export function SortDirectionButton (props: SortDirectionButtonProps): JSX.Element
{
    let stateIcon: iconName = 'caret_selector';
    if (props.isActiveSort)
        stateIcon = props.ascending ? 'caret_caretDown' : 'caret_caretUp';

    return (
        <Button variant='text' text='' size="32px" onClick={() => props.onClick(props.isActiveSort ? !props.ascending : true)} icon={stateIcon} />
    );
}



